var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1401_18910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00056 17.0358C13.4386 17.0358 17.0363 13.4381 17.0363 9.00007C17.0363 4.56207 13.4386 0.964355 9.00056 0.964355C4.56256 0.964355 0.964844 4.56207 0.964844 9.00007C0.964844 13.4381 4.56256 17.0358 9.00056 17.0358Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99907 9.74594C10.5519 9.74594 11.8106 8.48716 11.8106 6.93438C11.8106 5.38159 10.5519 4.1228 8.99907 4.1228C7.44628 4.1228 6.1875 5.38159 6.1875 6.93438C6.1875 8.48716 7.44628 9.74594 8.99907 9.74594Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7616 15.473C12.4288 16.4553 10.7817 17.0358 8.99899 17.0358C7.21628 17.0358 5.56915 16.4553 4.23633 15.473C4.50176 14.4734 5.07589 13.58 5.88046 12.9224C6.76056 12.203 7.8623 11.8101 8.99899 11.8101C10.1357 11.8101 11.2374 12.203 12.1175 12.9224C12.922 13.58 13.4962 14.4734 13.7616 15.473Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1401_18910"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.f0e53e2e5b99c7c39c9521143e956ff6.svg";
export { ForwardRef as ReactComponent };